import { NavLink } from 'react-router-dom';
import { List, ListItem } from 'material-ui/List';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Divider from 'material-ui/Divider';

const style = {
  padding: '15px 16px 15px 45px',
  fontSize: '15px',
};
// childern dropdown innerdiv styler
const styleChild = {
  padding: '12px 13px 12px 45px',
  fontSize: '14px',
  margin: '0px',
};

class RoutesListSuperadmin extends Component {
  constructor(props) {
    super(props);
    this.onModuleClick = this.onModuleClick.bind(this);
  }

  // componentWillReceiveProps(nextProps) {
  //   // let locationArr = location.pathname.split('/');
  //   // let patient_id;
  //   // if ((locationArr.length > 2) && (locationArr[2]) && locationArr[2] !== 0) {
  //   //   patient_id = (locationArr.length > 2) ? locationArr[2] : null;
  //   // } else if (locationArr[2] === 0) {
  //   //   patient_id = (locationArr.length > 2) ? locationArr[3] : null;
  //   // }
  //   console.log('mks--------', nextProps)
  //   if (nextProps.patientMenuShowStatus !== undefined && nextProps.patientInfo !== undefined) {
  //     this.setState({ patient_id: nextProps.patientInfo.PatientID });
  //   } else {
  //     this.setState({ patient_id: null });
  //   }
  // }

  onModuleClick(e) {
    this.props.toggleCloseMenu();
  }

  render() {
    // Parent list style
    const style = {
      padding: '12px 16px 12px 45px',
      fontSize: '15px',
    };
    // childern dropdown innerdiv styler

    return (
      this.props.loginUserInfo && this.props.loginUserInfo.roleName && this.props.loginUserInfo.roleName.toUpperCase() === 'SUPERADMIN' ?
      <List className="nav-menu">
        <ListItem
          key={100}
          primaryText="Dashboard"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">dashboard</i>}
          containerElement={<NavLink to="/webadmin/dashboard" exact />}
        />
        <ListItem
          key={101}
          primaryText="Manage Agency"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">group</i>}
          // className="submenu"
          containerElement={<NavLink to={'/webadmin/agency'} />}
        />
        <ListItem
          key={201}
          primaryText="Manage Database"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">storage</i>}
          // className="submenu"
          containerElement={<NavLink to={'/webadmin/manageDatabase'} />}
        />       
        <ListItem
          key={202}
          primaryText="Clearing House"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">contact_mail</i>}
          // className="submenu"
          containerElement={<NavLink to={'/webadmin/clearing-house'} />}
        />       
        <ListItem
          primaryText="Reports"
          innerDivStyle={style}
          initiallyOpen={false}
          primaryTogglesNestedList={true}
          className="childmenu"
          leftIcon={<i className="material-icons">assignment</i>}
          nestedItems={[
            <ListItem
              key={202}
              primaryText="Activated Clients"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/activatedclients" exact />}
            />,         
            <ListItem
              key={203}
              primaryText="Kronos Payroll Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/kronos-payroll-report" exact />}
            />,           
            <ListItem
              key={204}
              primaryText="Kronos Payroll With Total Mileage Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/kronos-payroll-with-total-mileage-report" exact />}
            />,  
            <ListItem
              key={205}
              primaryText="EBS Appointment Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/ebs-appointment-report" exact />}
            />,       
            <ListItem
              key={206}
              primaryText="EBS Monthly Revenue By Payer Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/ebs-monthly-revenue-by-payer-report" exact />}
            />, 
            <ListItem
              key={207}
              primaryText="EBS Authorization Details Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/ebs-authorization-details-report" exact />}
            />,      
            <ListItem
              key={501}
              primaryText="A/R Aging By Client Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/account-receivable-by-client-report" exact />}
            />,        
          ]}
        />
        <div className="menudivider">
          <Divider />
        </div>
      </List>
      : 
      <List className="nav-menu">
        <ListItem
          key={100}
          primaryText="Dashboard"
          innerDivStyle={style}
          onClick={(e) => this.onModuleClick(e)}
          leftIcon={<i className="material-icons">dashboard</i>}
          containerElement={<NavLink to="/webadmin/dashboard" exact />}
        />   
        <ListItem
          primaryText="Reports"
          innerDivStyle={style}
          initiallyOpen={false}
          primaryTogglesNestedList={true}
          className="childmenu"
          leftIcon={<i className="material-icons">assignment</i>}
          nestedItems={[
            <ListItem
              key={203}
              primaryText="Kronos Payroll Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/kronos-payroll-report" exact />}
            />,           
            <ListItem
              key={204}
              primaryText="Kronos Payroll With Total Mileage Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/kronos-payroll-with-total-mileage-report" exact />}
            />,       
            <ListItem
              key={205}
              primaryText="EBS Appointment Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/ebs-appointment-report" exact />}
            />,     
            <ListItem
              key={206}
              primaryText="EBS Monthly Revenue By Payer Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/ebs-monthly-revenue-by-payer-report" exact />}
            />, 
            <ListItem
              key={207}
              primaryText="EBS Authorization Details Report"
              innerDivStyle={styleChild}
              containerElement={<NavLink to="/webadmin/ebs-authorization-details-report" exact />}
            />,       
          ]}
        />
        <div className="menudivider">
          <Divider />
        </div>
      </List>
    );
  }
}

// export default RoutesListSuperadmin;

function mapStateToProps(state) {
  return {
    loginUserInfo: state.login.loginUserInfo,
  };
}

export default connect(mapStateToProps)(RoutesListSuperadmin);



// WEBPACK FOOTER //
// ./src/routers/routesListSuperadmin.js